'use client'

import React, { useEffect, useState } from "react"
import Swiper from "../ui/swiper/Swiper"
import Card from "./Card"
import { searchEducationCourses } from "@/api/helper"
import Link from "next/link"
import { createSearchPagePathname } from "@/services/pathname"

type OthersProps = {
    aroeven: Aroeven,
    educationCourse: EducationCourse
}

export default function Others({
    aroeven,
    educationCourse
}: OthersProps) {

    const [others, setOthers] = useState<EducationCourse[]>([])

    useEffect(() => {
        async function search() {
            const { items } = await searchEducationCourses(aroeven, {
                category: educationCourse.category
            })
            setOthers(items.filter(e => e.id !== educationCourse.id))
        }
        search()
    }, [])

    if (others.length === 0) {
        return <></>
    }

    return (
        <>
            <section className="suggestions bafa layout-pt-md layout-pb-md">
                <div data-aos="zoom-in-up" data-aos-duration={800} className="container">
                    <div className="row y-gap-10 justify-between items-end">
                        <div className="col-auto">
                            <h3 >Autres formations à découvrir</h3>
                            <h4>Les autres utilisateurs ont aussi regardé</h4>
                        </div>
                        <div className="col-sm-auto">
                            <Link href={createSearchPagePathname('object', 'EducationCourse', {
                                category: educationCourse.category
                            })} className="button-outline">Voir tout</Link>
                        </div>
                    </div>
                    <Swiper className={"vignette relative overflow-hidden pt-40 sm:pt-20 js-section-slider"}>
                        {others.map((other, indexOther) => {
                            return (
                                <React.Fragment key={'other-' + indexOther}>
                                    <div className="swiper-slide educform">
                                        <Card educationCourse={other} />
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </Swiper>
                </div>
            </section>
        </>
    )
}